/**
 * @generated SignedSource<<153fdeb976d23d4a9aee4e747a9628d9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_EnablePlacementMutation$variables = {
  id: string;
  isEnabled: boolean;
};
export type productSidePanelContent_EnablePlacementMutation$data = {
  readonly enablePlacementOutput: {
    readonly placementOutput: {
      readonly id: string;
      readonly isEnabled: boolean;
    } | null;
  };
};
export type productSidePanelContent_EnablePlacementMutation = {
  response: productSidePanelContent_EnablePlacementMutation$data;
  variables: productSidePanelContent_EnablePlacementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "isEnabled",
        "variableName": "isEnabled"
      }
    ],
    "concreteType": "PlacementOutput_Output",
    "kind": "LinkedField",
    "name": "enablePlacementOutput",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlacementOutput",
        "kind": "LinkedField",
        "name": "placementOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_EnablePlacementMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_EnablePlacementMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "9e4c660a611db6fd8a568975173a3085",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_EnablePlacementMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_EnablePlacementMutation(\n  $id: ID!\n  $isEnabled: Boolean!\n) {\n  enablePlacementOutput(id: $id, isEnabled: $isEnabled) {\n    placementOutput {\n      id\n      isEnabled\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4614006df89b371fd465eab88d728e54";

export default node;
